export const UPDATE_THEME = "UPDATE_THEME";
export const SET_SIDEBAR_VISIBILITY = "SET_SIDEBAR_VISIBILITY";
export const SET_SIDEBAR_OPEN_ALWAYS = "SET_SIDEBAR_OPEN_ALWAYS";

export const SET_ACTIVE_VARIABLE = "SET_ACTIVE_VARIABLE";
